/**
 * Survey Response model.
 *
 * @author jagpreet.singh@vernuso.com (Jagpreet Singh)
 */
export class SurveyResponse {
    questionId: number;
    optionId: number;
    responseText: string;
    organisationId: number;
    personId: number;
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/save-response.model.ts